import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";

interface Props {
  message: string | null;
  onHide: () => void;
  severity?: "error" | "info" | "success" | "warning";
}

const AlertComponent = forwardRef<
  HTMLDivElement,
  {
    severity: "error" | "info" | "success" | "warning";
    onClose: (event: React.SyntheticEvent) => void;
    children: React.ReactNode;
  }
>((props, ref) => (
  <Alert ref={ref} elevation={6} variant="filled" {...props} />
));
AlertComponent.displayName = "AlertComponent";

export const NotificationSnackBar = ({
  message,
  onHide = () => {},
  severity = "success",
}: Props) => {
  const handleClose = (
    _event: React.SyntheticEvent | Event,
    reason: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    onHide();
  };

  const handleAlertClose = (_event: React.SyntheticEvent) => {
    onHide();
  };

  const [open, setOpen] = useState(!!message);
  useEffect(() => {
    setOpen(!!message);
  }, [message]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <AlertComponent severity={severity} onClose={handleAlertClose}>
        {message}
      </AlertComponent>
    </Snackbar>
  );
};
